/* VIMZO CREATIONS – global theme script
   Cart (Shopify AJAX Cart API + Section Rendering API), drawers, header,
   quantity inputs, collection filters and reveal animations. */
(function () {
  'use strict';

  var V = (window.VIMZO = window.VIMZO || {});
  var routes = V.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add.js', cartChange: '/cart/change.js' };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Money ---------- */
  V.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || V.moneyFormat || 'Rs. {{amount_no_decimals}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    function fmt(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      default: value = fmt(cents, 2);
    }
    return match ? format.replace(match[0], value) : value;
  };

  /* ---------- Toast ---------- */
  var toastTimer;
  V.toast = function (message) {
    var el = document.querySelector('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.hidden = true; }, 300);
    }, 3200);
  };

  /* ---------- Drawers (menu + cart) with focus trap ---------- */
  var openDrawerEl = null;
  var lastFocus = null;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function openDrawer(name) {
    var drawer = document.querySelector('[data-drawer="' + name + '"]');
    if (!drawer) return;
    if (openDrawerEl && openDrawerEl !== drawer) closeDrawer(true);
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.documentElement.classList.add('is-locked');
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      var panel = drawer.querySelector('.drawer__panel');
      if (panel) panel.focus({ preventScroll: true });
    });
    openDrawerEl = drawer;
    if (name === 'menu') {
      var t = document.querySelector('[data-menu-open]');
      if (t) t.setAttribute('aria-expanded', 'true');
    }
  }

  function closeDrawer(skipFocus) {
    if (!openDrawerEl) return;
    var drawer = openDrawerEl;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('is-locked');
    var t = document.querySelector('[data-menu-open]');
    if (t) t.setAttribute('aria-expanded', 'false');
    setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, reduceMotion ? 0 : 320);
    openDrawerEl = null;
    if (!skipFocus && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  V.openCart = function () {
    if (V.cartType === 'page' || document.body.classList.contains('template-cart')) {
      if (!document.body.classList.contains('template-cart')) window.location.href = routes.cart;
      return;
    }
    openDrawer('cart');
  };

  document.addEventListener('keydown', function (e) {
    if (!openDrawerEl) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    var items = Array.prototype.filter.call(openDrawerEl.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null;
    });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement.classList.contains('drawer__panel'))) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  });

  /* ---------- Section rendering helpers ---------- */
  function sectionIds() {
    var ids = [];
    document.querySelectorAll('[data-section-render]').forEach(function (el) {
      var id = el.getAttribute('data-section-render');
      if (ids.indexOf(id) === -1) ids.push(id);
    });
    if (ids.indexOf('cart-drawer') === -1) ids.push('cart-drawer');
    return ids;
  }

  function renderSections(sections) {
    if (!sections) return;
    var count = null;
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-section-render="' + id + '"]');
      if (!fresh) return;
      if (fresh.hasAttribute('data-cart-count-value')) count = parseInt(fresh.getAttribute('data-cart-count-value'), 10);
      document.querySelectorAll('[data-section-render="' + id + '"]').forEach(function (el) {
        el.innerHTML = fresh.innerHTML;
        if (fresh.hasAttribute('data-cart-count-value')) el.setAttribute('data-cart-count-value', fresh.getAttribute('data-cart-count-value'));
      });
    });
    if (count !== null) updateCount(count);
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.hidden = count === 0;
      el.innerHTML = '<span aria-hidden="true">' + count + '</span><span class="visually-hidden">' + count + ' items</span>';
      el.classList.remove('is-bumped');
      void el.offsetWidth;
      el.classList.add('is-bumped');
    });
  }

  /* ---------- Cart API ---------- */
  V.addToCart = function (formData) {
    var ids = sectionIds();
    formData.append('sections', ids.join(','));
    formData.append('sections_url', window.location.pathname);
    return fetch(routes.cartAdd, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) {
          var msg = (res.json && (res.json.description || res.json.message)) || V.strings.error;
          throw new Error(msg);
        }
        renderSections(res.json.sections);
        document.dispatchEvent(new CustomEvent('vimzo:cart-added', { detail: res.json }));
        return res.json;
      });
  };

  var changeQueue = Promise.resolve();
  V.changeLine = function (key, quantity) {
    changeQueue = changeQueue.then(function () {
      document.querySelectorAll('[data-cart-line][data-key="' + key + '"]').forEach(function (el) { el.classList.add('is-loading'); });
      return fetch(routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: sectionIds(), sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
        .then(function (res) {
          if (!res.ok || res.json.status) throw new Error(res.json.description || res.json.message || V.strings.error);
          renderSections(res.json.sections);
          if (quantity === 0) V.toast('Item removed from cart');
          return res.json;
        })
        .catch(function (err) {
          V.toast(err.message || V.strings.error);
          document.querySelectorAll('[data-cart-line].is-loading').forEach(function (el) { el.classList.remove('is-loading'); });
        });
    });
    return changeQueue;
  };

  /* ---------- Quantity inputs ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var wrap = step.closest('[data-qty]');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var max = parseInt(input.max || '99', 10);
    var val = (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-qty-step'), 10);
    input.value = Math.min(max, Math.max(min, val));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  var qtyTimers = {};
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (input.matches('[data-line-qty]')) {
      var key = input.getAttribute('data-key');
      clearTimeout(qtyTimers[key]);
      qtyTimers[key] = setTimeout(function () {
        V.changeLine(key, Math.max(0, parseInt(input.value, 10) || 0));
      }, 350);
    }
    if (input.matches('[data-cart-note]')) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: input.value })
      });
    }
  });

  /* ---------- Global click delegation ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var remove = t.closest('[data-line-remove]');
    if (remove) {
      e.preventDefault();
      V.changeLine(remove.getAttribute('data-key'), 0);
      return;
    }

    if (t.closest('[data-cart-open]')) {
      if (V.cartType === 'page' || document.body.classList.contains('template-cart')) return;
      e.preventDefault();
      openDrawer('cart');
      return;
    }

    if (t.closest('[data-menu-open]')) { e.preventDefault(); openDrawer('menu'); return; }
    if (t.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }
    if (t.closest('[data-drawer-close-link]')) { closeDrawer(true); return; }

    var searchToggle = t.closest('[data-search-toggle]');
    if (searchToggle) { toggleSearch(); return; }
    if (t.closest('[data-search-close]')) { toggleSearch(false); return; }

    var recover = t.closest('[data-toggle-recover]');
    if (recover) {
      var card = document.getElementById('RecoverCard');
      if (card) { e.preventDefault(); card.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' }); var i = card.querySelector('input'); if (i) i.focus(); }
    }
  });

  /* ---------- AJAX product forms (plain add to cart) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-ajax-cart]')) return;
    if (V.cartType === 'page') return;
    e.preventDefault();
    var submitter = e.submitter || document.querySelector('[form="' + form.id + '"][type="submit"]');
    var scope = form.closest('[data-product]') || document;
    var errorEl = scope.querySelector('[data-form-error]');
    var labelEl = submitter && submitter.querySelector('[data-add-label]');
    var original = labelEl ? labelEl.textContent : '';
    if (submitter) { submitter.disabled = true; submitter.classList.add('is-loading'); }
    if (labelEl) labelEl.textContent = V.strings.adding;
    if (errorEl) errorEl.hidden = true;

    var fd = new FormData(form);
    // Quantity inputs linked with the form="" attribute are included automatically by FormData in modern browsers;
    // add a fallback for older ones.
    if (!fd.has('quantity')) {
      var q = document.querySelector('input[name="quantity"][form="' + form.id + '"]');
      if (q) fd.append('quantity', q.value);
    }

    V.addToCart(fd)
      .then(function () {
        if (labelEl) labelEl.textContent = V.strings.added;
        V.openCart();
        setTimeout(function () { if (labelEl) labelEl.textContent = original; }, 1800);
      })
      .catch(function (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        if (labelEl) labelEl.textContent = original;
      })
      .finally(function () {
        if (submitter) { submitter.disabled = false; submitter.classList.remove('is-loading'); }
      });
  });

  /* ---------- Header: search + sticky shadow ---------- */
  function toggleSearch(force) {
    var panel = document.querySelector('[data-search-panel]');
    var btn = document.querySelector('[data-search-toggle]');
    if (!panel) return;
    var show = typeof force === 'boolean' ? force : panel.hidden;
    panel.hidden = !show;
    if (btn) btn.setAttribute('aria-expanded', String(show));
    if (show) {
      var input = panel.querySelector('input[type="search"]');
      if (input) input.focus();
    } else if (btn) {
      btn.focus();
    }
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var panel = document.querySelector('[data-search-panel]');
      if (panel && !panel.hidden) toggleSearch(false);
    }
  });

  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Announcement rotation ---------- */
  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var msgs = bar.querySelectorAll('.announcement__msg');
    if (msgs.length < 2 || reduceMotion) return;
    var i = 0;
    var interval = parseInt(bar.getAttribute('data-interval'), 10) || 5000;
    var timer = setInterval(next, interval);
    bar.addEventListener('mouseenter', function () { clearInterval(timer); });
    bar.addEventListener('mouseleave', function () { timer = setInterval(next, interval); });
    function next() {
      msgs[i].classList.remove('is-active');
      msgs[i].setAttribute('aria-hidden', 'true');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
      msgs[i].removeAttribute('aria-hidden');
    }
  });

  /* ---------- Collection filters: submit on change ---------- */
  document.querySelectorAll('[data-facet-form]').forEach(function (form) {
    var timer;
    function submit() {
      var params = new URLSearchParams(new FormData(form));
      var clean = new URLSearchParams();
      params.forEach(function (v, k) { if (v !== '') clean.append(k, v); });
      window.location.href = form.getAttribute('action') + '?' + clean.toString();
    }
    form.addEventListener('change', function (e) {
      clearTimeout(timer);
      timer = setTimeout(submit, e.target.matches('[data-price-input]') ? 700 : 50);
    });
  });
  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var form = document.getElementById(select.getAttribute('form'));
      if (form) {
        form.dispatchEvent(new Event('change'));
      } else {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        window.location.href = url.toString();
      }
    });
  });
  // Open the filter panel by default on desktop
  var filterDetails = document.querySelector('[data-filters-details]');
  if (filterDetails) {
    var mq = window.matchMedia('(min-width: 990px)');
    var syncFilters = function () { if (mq.matches) filterDetails.open = true; };
    syncFilters();
    mq.addEventListener ? mq.addEventListener('change', syncFilters) : mq.addListener(syncFilters);
  }

  /* ---------- Reveal on scroll ---------- */
  if (document.body.classList.contains('has-reveal') && 'IntersectionObserver' in window && !reduceMotion) {
    document.documentElement.classList.add('reveal-ready');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    var observeAll = function (root) {
      (root || document).querySelectorAll('[data-reveal]:not(.is-visible)').forEach(function (el) { io.observe(el); });
    };
    observeAll();
    document.addEventListener('shopify:section:load', function (e) { observeAll(e.target); });
  }

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('[data-drawer="cart"]')) openDrawer('cart');
  });
  document.addEventListener('shopify:section:deselect', function () { closeDrawer(true); });

  // Restore page from back/forward cache with a fresh cart count
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    fetch(routes.root + '?sections=' + sectionIds().join(','), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderSections)
      .catch(function () {});
  });
})();
